import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import Parser from 'html-react-parser';
import axios from 'axios';
import Swal from 'sweetalert2'; // Import SweetAlert2
import { API_BASE_URL } from '../../api';
import Loader from './Loader';

const ProjectLedgerInner = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { id } = useParams();
    const authToken = localStorage.getItem('authToken');
    const userId = localStorage.getItem('userId');

    useEffect(() => {
        fetchLedger();
    }, [id]);

    const fetchLedger = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/project/${id}/ledger`, {
                headers: {
                    authorization: `Bearer ${authToken}`,
                    user_id: userId,
                },
            });
            setData(response.data);
        } catch (err) {
            setError('Error fetching ledger data');
        } finally {
            setLoading(false);
        }
    };

    const deleteLedger = async (rowId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${API_BASE_URL}/api/ledger/${rowId}`, {
                        headers: {
                            authorization: `Bearer ${authToken}`,
                            user_id: userId,
                        },
                    });
                    Swal.fire('Deleted!', 'The ledger entry has been deleted.', 'success');
                    fetchLedger(); // Refresh the ledger data
                } catch (err) {
                    console.error("API error:", err.response ? err.response.data : err);
                    Swal.fire('Error!', 'Something went wrong while deleting the entry.', 'error');
                }
            }
        });
    };

    const toCamelCase = (str) => {
        const camelCased = str.replace(/_([a-z])/g, (match, group1) => group1.toUpperCase());
        return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
    };

    const renderLedgerTableTotal = () => {

        const totalCredit = data.map((row) => row.credit).reduce((a, b) => a + b, 0);
        const totalDebit = data.map((row) => row.debit).reduce((a, b) => a + b, 0);
        return (<tfoot><tr>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td><b>{formatINR(Math.round(totalDebit))}</b></td>
            <td><b>{formatINR(Math.round(totalCredit))}</b></td>
        </tr><tr>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td><b>{formatINR(Math.round(parseFloat(totalDebit) - parseFloat(totalCredit)))}</b></td>
            </tr></tfoot>);
    }



    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    useEffect(() => {
        setCurrentPage(1);
    }, [search,itemsPerPage]);

    const filteredData = data.filter((ledger) =>
        [
            ledger.firm,
            ledger.date,
            ledger.title,
            ledger.start_date,
            ledger.end_date,
            ledger.debit,
            ledger.credit,
            ledger.renewal_month,
        ]
            .filter(Boolean) // Prevent errors from null values
            .some((field) => field.toString().toLowerCase().includes(search))
    );

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, startIndex + parseInt(itemsPerPage));
    // console.log(startIndex);
    // console.log(startIndex + parseInt(itemsPerPage));

    
    const formatINR = (amount) => {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 2,
        }).format(amount);
    };
    
    if (loading) {
        return <div> <p>Loading..</p> </div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="card-body p-0">
            <div className="table-responsive custom-datatable-filter">
                <div className="row mt-2 justify-content-between mb-3">
                    <div className="d-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
                        <label htmlFor="dt-length-0"> entries per page</label>
                        <select aria-controls="datatable" className="form-select form-select-sm" id="dt-length-0" value={itemsPerPage}
                            onChange={(e) => setItemsPerPage(e.target.value)}>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div className="d-md-flex justify-content-between align-items-center dt-layout-end col-md-auto ms-auto">
                        <label htmlFor="dt-search-0" className="form-label me-2 visually-hidden">Search:</label>
                        <input
                            type="text"
                            placeholder="Search..."
                            className="p-2 border rounded mb-4 w-full"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>
                <table className="table table-bordered dataTable" id="datatable">
                    <thead>
                        <tr>
                            <th>Action</th>
                            <th>SR.No</th>
                            <th>Retainer</th>
                            <th>FIRM</th>
                            <th>Date</th>
                            <th>Title</th>
                            <th>Debit</th>
                            <th>Credit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedData.map((entry, index) => (
                            <tr key={entry.id || index} id={`ledger${entry.id}`}>
                                <td>
                                    {
                                        entry.parent_id == null ? 
                                        <Link to={`/dashboard/add-ledger/${entry.project_id}/${entry.client_id}/${entry.id}`} title="Add Payment" className='mr-3'> Add ₹</Link> : ""
                                    }
                                    <Link to={`/dashboard/edit-ledger/${entry.id}`} title="Edit">
                                        <i className="fas fa-edit text-primary ms-3"></i>
                                    </Link>
                                    <i
                                        className="fas fa-trash text-danger ms-3"
                                        title="Delete"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => deleteLedger(entry.id)}
                                    ></i>

                                </td>
                                <td> {((currentPage - 1) * itemsPerPage) + (index + 1)}</td>
                                <td>{Parser(entry.retainer == 1 && entry.credit ==  0 ? "Retainer" : "" )}</td>
                                <td>{entry.firm}</td>
                                <td>{entry.date}</td>
                                <td>{toCamelCase(entry.title)}
                                    {Parser(entry.start_date != null ? '<br>Start Date: ' + entry.start_date : "")}{Parser(entry.start_date != null ? '<br>End Date: ' + entry.end_date : "")}{Parser(entry.renewal_month != null ? "<br>Renewal time : " + entry.renewal_month + " month" : "")}{Parser(entry.parent != null ? "<br><a href='#ledger" + entry.parent.id + "'><small>" + entry.parent.title + "</small></a>" : "")}</td>
                                            <td>{formatINR(entry.debit)}</td>
                                            <td>{formatINR(entry.credit)}</td>
                            </tr>
                        ))}
                    </tbody>
                    {renderLedgerTableTotal()}
                </table>
                <div className="flex justify-center mt-4">
                    <button
                        className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        Prev
                    </button>
                    <span className="px-3 py-1">Page {currentPage} of {totalPages}</span>
                    <button
                        className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProjectLedgerInner;
